import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "application-center" }
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = { class: "application-main-box" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "application-name" }
const _hoisted_6 = { class: "application-main-name" }
const _hoisted_7 = { class: "application-sub-btn" }
const _hoisted_8 = ["src"]

import router from '@/router/index';

// 应用盒子
interface AppBox {
  key: string; // 唯一标识
  name: string; // 名称
  appList: App[]; // 应用列表
}

// 应用
interface App {
  key: string; // 唯一标识
  name: string; // 名称
  icon?: string; // 图标
  background?: string; // 背景
  img?: string; // 图片
  path: string; // 路径
  disabled: boolean; // 是否禁用
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const appBoxList: AppBox[] = [
  {
    key: 'multilingualTools',
    name: '多语言工具',
    appList: [
      {
        key: 'videoTranslate',
        name: '视频多语言翻译',
        icon: 'appVideo',
        background: '',
        path: '/video-translate',
        disabled: false,
      },
    ],
  },
  {
    key: 'videoTools',
    name: '视频工具',
    appList: [
      // {
      //   key: 'aiPlanTask',
      //   name: 'AI 剪辑',
      //   icon: 'aiEditing',
      //   background: '',
      //   path: '/new-video?navsType=aiClip',
      //   disabled: false,
      // },
      {
        key: 'pdfToVideo',
        name: 'PDF 转视频',
        icon: 'appPDF',
        background: '',
        path: '/pdf-to-video',
        disabled: false,
      },
    ],
  },
  {
    key: 'ai',
    name: 'AI 助理',
    appList: [
      {
        key: 'aiPlanTask',
        name: 'AI 策划',
        icon: 'plan',
        background: '',
        path: '/ai-plan-task',
        disabled: false,
      },
    ],
  },
  {
    key: 'aiTools',
    name: 'AI 工具',
    appList: [
      // {
      //   key: 'xhsAssistant',
      //   name: '小红书智能助手',
      //   img: require('@/assets/images/xhs-assistant.webp'),
      //   path: '/xhs-assistant',
      //   disabled: false,
      // },
      {
        key: 'copywritingAssistant',
        name: 'AI文案助手',
        img: require('@/assets/images/icon-zhutimiaoshu.png'),
        path: '/copywriting-assistant',
        disabled: false,
      },
    ],
  },
  // {
  //   key: 'lives',
  //   name: '直播',
  //   appList: [
  //     {
  //       key: 'aiLives',
  //       name: 'AI 直播',
  //       img: require('@/assets/images/自动回复item.png'),
  //       path: '/open-ai-Lives',
  //       disabled: false,
  //     },
  //   ],
  // },
];

const go = (path, disabled) => {
  if (disabled) return;
  router.push(path);
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(appBoxList, (appBox) => {
      return _createElementVNode("div", {
        class: "application-outbox dark-border",
        key: appBox.key
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(appBox.name), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appBox.appList, (app, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["application-item", { disabled: app.disabled }]),
              key: app.key,
              style: _normalizeStyle({ backgroundImage: `url(${app.background})` }),
              onClick: ($event: any) => (go(app.path, app.disabled))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(app.name), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(app.disabled ? '敬请期待' : '立即使用'), 1)
              ]),
              (app.icon)
                ? (_openBlock(), _createBlock(_component_svg_icon, {
                    key: 0,
                    class: "application-icon",
                    "icon-class": app.icon,
                    width: "60px",
                    height: "100%"
                  }, null, 8, ["icon-class"]))
                : (app.img)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "application-icon",
                      width: "60px",
                      height: "100%",
                      src: app.img,
                      alt: ""
                    }, null, 8, _hoisted_8))
                  : _createCommentVNode("", true)
            ], 14, _hoisted_4))
          }), 128))
        ])
      ])
    }), 64))
  ]))
}
}

})